import { render } from "./ModuleComponent.vue?vue&type=template&id=5f2081b9"
import script from "./ModuleComponent.vue?vue&type=script&lang=js"
export * from "./ModuleComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__